import gql from 'graphql-tag'
import {
  Department,
  DepartmentPaginator,
  EventAccessibilityMode,
  EventAccessibilityModePaginator,
  EventActivityType,
  EventActivityTypePaginator,
  EventDateRange,
  // EventTarget,
  // EventTargetPaginator,
} from 'src/types/fam-graphql'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'

const query = gql`
  query filters {
    departments(first: 500) {
      data {
        id
        name
        code
      }
    }
    eventAccessibilityModes(first: 500) {
      data {
        id
        name
      }
    }
    eventActivityTypes(first: 500) {
      data {
        id
        title
      }
    }
    # eventTargets(first: 500) {
    #   data {
    #     id
    #     name
    #   }
    # }
    getEventDates {
      start
      end
    }
  }
`

const transformer = ({
  departments,
  eventAccessibilityModes,
  eventActivityTypes,
  // eventTargets,
  getEventDates,
}: {
  departments: DepartmentPaginator
  eventAccessibilityModes: EventAccessibilityModePaginator
  eventActivityTypes: EventActivityTypePaginator
  // eventTargets: EventTargetPaginator
  getEventDates: EventDateRange[]
}): {
  departments: Department[]
  eventAccessibilityModes: EventAccessibilityMode[]
  eventActivityTypes: EventActivityType[]
  // eventTargets: EventTarget[]
  eventDates: EventDateRange[]
} => ({
  departments: departments.data,
  eventAccessibilityModes: eventAccessibilityModes?.data ?? [],
  eventActivityTypes: eventActivityTypes?.data ?? [],
  // eventTargets: eventTargets?.data ?? [],
  eventDates: getEventDates ?? [],
})

type variables = null

export default queryServiceCreator<variables>(query, transformer)
